














import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class SocialLinks extends Vue {
  @Prop({ default: "" }) readonly extraClass!: string;
  @Prop() readonly shopDetails!: MerchantShopDetails
}
